import BaseMapper from '../../BaseMapper';

const OutcomeDescriptionMapper = (data, context) => {
    return data;
};

export default OutcomeDescriptionMapper;
